// extracted by mini-css-extract-plugin
export var colorSquare = "_ow-0";
export var danger = "_ow-5";
export var lightPink = "_ow-8";
export var neutralBlue = "_ow-7";
export var neutralYellow = "_ow-6";
export var normal = "_ow-1";
export var primary = "_ow-2";
export var primaryLight = "_ow-3";
export var solidBlack = "_ow-g";
export var solidGreen = "_ow-b";
export var solidLightBlue = "_ow-d";
export var solidNavy = "_ow-c";
export var solidOrange = "_ow-f";
export var solidPink = "_ow-e";
export var solidRed = "_ow-9";
export var solidYellow = "_ow-a";
export var success = "_ow-4";